import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Columns from './Columns';
import RowLabels from './RowLabels';
import Labels from './Labels';
import BipolarPairImages from '../BipolarPairImages';

export default function BipolarHorizontal({
  rows,
  labels,
  minWidth,
  minAnswerWidth,
}) {
  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Fragment>
          <div
            id={row.id}
            className="answer--bipolar bipolar-horizontal scrollbox"
            data-row-order={index}
          >
            <RowLabels rowLabels={row.rowLabels} minWidth={minWidth} />
            <BipolarPairImages
              beforeImage={row.beforeImage}
              afterImage={row.afterImage}
              minWidth={minWidth}
            />
            <Columns columns={row.columns} minWidth={minWidth} />
            <Labels
              labels={labels}
              minWidth={minWidth}
              minAnswerWidth={minAnswerWidth}
            />
          </div>
          {index < rows.length - 1 && (
            <div className="divider margin-md-btm"></div>
          )}
        </Fragment>
      ))}
    </div>
  );
}

BipolarHorizontal.propTypes = {
  rows: PropTypes.array,
  labels: PropTypes.array,
  minWidth: PropTypes.number,
  minAnswerWidth: PropTypes.number,
};
